import React, { useEffect } from 'react';
import Module from '../../../../layout/Module';
import Tabs from '../Tabs';
import DataGrid from '../../../../table/DataGrid';
import useMySurveys from '../../../../../hooks/data-entry/useMySurver';
import { useSelector } from 'react-redux';
import FormatDate from '../../../../date/FormatDate';
import StatusChip from '../../components/StatusChip/StatusChip';
import DialogPreviewAboutMe from '../../components/DialogPreviewAboutMe/DialogPreviewAboutMe';
import IconTooltipButton from '../../../../button/IconTooltipButton';

const AboutMeSurveyList = () => {
  const { getMySurveysAboutMe, onShareLink } = useMySurveys();
  const [modal, setModal] = React.useState(null);

  const state = null;
  const skip = useSelector((state) => state?.datatable?.aboutMeSurverList?.skip || 0);
  const rowsPerPage = useSelector((state) => state?.datatable?.aboutMeSurverList?.rowsPerPage || 50);
  const columnsTable = useSelector((state) => state?.datatable?.aboutMeSurverList?.columnsTable || []);

  const list = useSelector((state) => state?.dataEntryMySurveys?.aboutMe?.list ?? []);
  const totalRecords = useSelector((state) => state?.dataEntryMySurveys?.aboutMe?.totalRecords ?? 0);
  const loading = useSelector((state) => state?.dataEntryMySurveys?.aboutMe?.loading ?? false);

  useEffect(() => {
    getMySurveysAboutMe(skip, rowsPerPage, state?.filter);
  }, [rowsPerPage, skip, state, state?.filter]);

  const getStatusChip = (survey) => {
    let type = '';
    let content = '';

    if (survey?.hasExpired) {
      type = 'error';
      content = 'Closed';
    } else {
      type = 'active';
      content = 'Active';
    }
    return (
      <div className='flex items-center justify-center'>
        <StatusChip content={content} type={type} />
      </div>
    );
  };

  return (
    <Module>
      <Module.Header title='My Surveys' titleLink={'/dashboard/data-entry/my-surveys/about-me'} />
      <Module.Body>
        <Module.BodyHeader>
          <Tabs />
        </Module.BodyHeader>
        <Module.BodyContainer classNameWrapper='overflow-auto'>
          <DataGrid
            id='table-mysurveys-about-me'
            loading={loading}
            rows={list.map((row, index) => ({
              ...row,
              index: index + 1,
              name: row?.name || '-',
              creator: row?.createdBy?.fullName || '',
              questions:
                row.template?.questions?.filter((question) => question?.type?.value !== 'groupreference')
                  ?.length || 0,
              status: <>{getStatusChip(row)}</>,
              dateFilledOut: row?.result?.dateFilledOut ? (
                <FormatDate date={row?.result?.dateFilledOut} />
              ) : null,
              date: row?.dueDate ? <FormatDate date={row?.dueDate} /> : null,
              note: row?.notes || '',
              completed: `${row?.resultsLength || 0} user${row?.resultsLength > 1 ? 's' : ''}`,
              actions: (
                <div className='flex items-center gap-1 items-center justify-center'>
                  <IconTooltipButton
                    id={`survey-preview-${row._id}`}
                    disabled={loading}
                    title='Preview'
                    icon='expand-alt'
                    onClick={() =>
                      setModal({
                        open: true,
                        data: {
                          _id: row.users?._id,
                          type: row.type,
                          recordId: row?.users?._id,
                          surveyId: row._id,
                          questions: row.template?.questions || [],
                          results: row.results || [],
                          survey: row.name,
                          hasExpired: row.hasExpired,
                          ...row.users
                        }
                      })
                    }
                  />
                  {!row.hasExpired ? (
                    <IconTooltipButton
                      id={`share-link-${row._id}`}
                      disabled={loading}
                      title='Share link'
                      icon='share-alt'
                      onClick={() =>
                        onShareLink(row._id, {
                          _id: row?.users?._id
                        })
                      }
                    />
                  ) : (
                    <div className='px-4' />
                  )}
                </div>
              )
            }))}
            labelNoRows="You don't have any survey yet"
            nameModule='mySurveysList'
            skip={skip}
            totalRows={totalRecords}
            rowsPerPage={rowsPerPage}
            columns={[
              {
                label: '#',
                key: 'index',
                align: 'center',
                width: 10,
                show: true,
                hide: false
              },
              ...columnsTable,
              {
                label: 'Actions',
                key: 'actions',
                align: 'center',
                show: true,
                hide: false
              }
            ]}
            orderByField='name'
          />
        </Module.BodyContainer>
      </Module.Body>
      {modal && (
        <DialogPreviewAboutMe
          surveyId={modal.data?.surveyId}
          recordId={modal.data?.recordId}
          type={modal.data?.type}
          open={modal.open}
          loading={loading}
          onClose={() => setModal(null)}
          onShareLink={modal?.data?.hasExpired ? undefined : (row) => onShareLink(modal?.data?.surveyId, row)}
        />
      )}
    </Module>
  );
};

export default AboutMeSurveyList;
